var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuruculLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 26,
    viewBox: "0 0 152 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10122672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10122570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.0605 12.0067H56.5336V25.463H52.4168V19.8299C51.4425 22.7395 49.1811 25.8381 44.2784 25.8381C38.4963 25.8381 33.1874 21.301 33.1874 13.5722C33.1874 5.84352 38.0589 1.30487 45.0348 1.30487C50.848 1.30487 54.7748 4.05782 56.1896 9.12815H51.0052C50.0947 6.75032 48.1772 5.21729 45.0348 5.21729C40.9508 5.21729 38.3111 8.50347 38.3111 13.5722C38.3111 18.641 41.0441 21.9272 45.2542 21.9272C48.9616 21.9272 51.5064 19.7369 51.6324 15.9501H44.0605V12.0067Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.5984 8.47101H75.4061V25.463H70.6622V22.1149C69.8762 24.1486 68.2746 25.8382 65.2894 25.8382C61.3299 25.8382 59.6646 22.9907 59.6646 19.2348V8.47101H64.4723V18.2024C64.4723 21.1445 65.5727 22.49 67.5509 22.49C69.5291 22.49 70.5984 21.05 70.5984 18.1404V8.47101Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.3527 12.915C84.0126 10.2551 85.7402 8.09579 89.0398 8.09579V12.7895H87.8149C84.8297 12.7895 83.3854 13.7908 83.3854 16.6693V25.463H78.5776V8.47092H83.3543V12.915H83.3527Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M101.396 8.47101H106.204V25.463H101.46V22.1149C100.674 24.1486 99.0721 25.8382 96.0869 25.8382C92.1274 25.8382 90.462 22.9907 90.462 19.2348V8.47101H95.2698V18.2024C95.2698 21.1445 96.3702 22.49 98.3484 22.49C100.327 22.49 101.396 21.05 101.396 18.1404V8.47101Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M108.466 16.9514C108.466 11.6315 112.08 8.09579 117.296 8.09579C121.789 8.09579 124.899 10.5992 125.623 14.5736H120.784C120.376 12.7895 119.276 11.351 117.296 11.351C114.751 11.351 113.369 13.5102 113.369 16.953C113.369 20.3957 114.815 22.586 117.296 22.586C119.276 22.586 120.407 21.3971 120.941 19.4254H125.78C124.963 23.5873 121.57 25.8396 117.296 25.8396C112.018 25.8396 108.466 22.3039 108.466 16.953V16.9514Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M138.504 8.47101H143.311V25.463H138.567V22.1149C137.781 24.1486 136.18 25.8382 133.195 25.8382C129.235 25.8382 127.57 22.9907 127.57 19.2348V8.47101H132.378V18.2024C132.378 21.1445 133.478 22.49 135.456 22.49C137.434 22.49 138.504 21.05 138.504 18.1404V8.47101Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M146.471 25.4629V1.67996H151.278V25.4614H146.471V25.4629Z",
    fill: "#4A0077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 10122667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10122630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.8739 13.2444L27.1435 7.91963L20.0758 0.880615H7.18817L0 8.03957L5.39009 13.3312L13.5583 5.08045L21.8739 13.2444Z",
    fill: "#4A0077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.8739 13.244L13.7058 21.4948L5.39014 13.3309L0.120483 18.6556L7.18822 25.6946H20.0759L27.264 18.5357L21.8739 13.244Z",
    fill: "#4A0077"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuruculLogo);
export default __webpack_public_path__ + "static/media/gurucul-logo.c5bd6c543c0a78be1f2d7ac61c90d352.svg";
export { ForwardRef as ReactComponent };